import React from 'react';
import PropTypes from 'prop-types';
import constants from '../Constants';

/*
const AddButton = (props) => {
    const { onVehicleClick, sequence } = props;
    console.log(onVehicleClick);
    return (
        <button
            onClick={() => onVehicleClick(sequence)}
            className="btn btn-primary">
            Add
        </button>
    );
}
*/

const RemoveButton = (props) => {
    //const { onVehicleClick } = props;
    //console.log(onVehicleClick);
    return (
        <button
            //onClick={() => onVehicleClick(sequence)}
            className="btn btn-danger">
            <i className={constants.icons.remove} />
            {` Remove`}
        </button>
    );
}

const VehicleItem = (props) => {
    return (
        <div className="summary-list-item">
            <div className="row">
                <div className="col-md-8 item-data">
                    {props.name}
                </div>
                <div className="col-md-4">
                    <RemoveButton {...props} />
                </div>
            </div>
        </div>
    )
}

export default VehicleItem;

VehicleItem.propTypes = {
    name: PropTypes.string.isRequired
}


// WEBPACK FOOTER //
// ./src/Review/VehiclesItem.js